import { Apis } from "../../lib/Apis";

export const usePricing = () => {
    const getPricing = async (setPricingList) => {
        try {
            const response = await Apis.getPricing();
            if (response.status === 200) {
                setPricingList(response.data);
            }
        } catch (error) {
            console.error("Failed to fetch pricing list:", error);
            setPricingList([]);
        }
    };
    const addPricing = async (data) => {
        try {
            const response = await Apis.createPricing(data);
            if (response.status === 200) {
                return response.data;
            }
        } catch (error) {
            throw new Error("Failed to add pricing data.");
        }
    };
    const updatePricing = async (id, data) => {
        try {
            const response = await Apis.updatePricing(id, data);
            if (response.status === 200) {
                return response.data;
            }
        } catch (error) {
            throw new Error("Failed to update pricing data.");
        }
    };
    const deletePricing = async (id) => {
        try {
            const response = await Apis.deletePricing(id);
            if (response.status === 200) {
                return response.data;
            }
        } catch (error) {
            throw new Error("Failed to delete pricing data.");
        }
    };

    return {
        getPricing,
        addPricing,
        updatePricing,
        deletePricing,
    };
};

export const usePremiumPricing = () => {
    const getPremiumPricing = async (setList) => {
        try {
            const response = await Apis.getPremiumPricing();
            if (response.status === 200) {
                setList(response.data);
            }
        } catch (error) {
            console.error("Failed to fetch premium pricing list:", error);
            setList([]);
        }
    };
    const addPremiumPricing = async (data) => {
        try {
            const response = await Apis.createPremiumPricing(data);
            if (response.status === 200 || response.status === 201) {
                return response.data;
            }
        } catch (error) {
            throw new Error("Failed to add premium pricing data.");
        }
    };
    const updatePremiumPricing = async (id, data) => {
        try {
            const response = await Apis.updatePremiumPricing(id, data);
            if (response.status === 200) {
                return response.data;
            }
        } catch (error) {
            throw new Error("Failed to update premium pricing data.");
        }
    };
    const deletePremiumPricing = async (id) => {
        try {
            const response = await Apis.deletePremiumPricing(id);
            if (response.status === 200 || response.status === 204) {
                return response.data;
            }
        } catch (error) {
            throw new Error("Failed to delete premium pricing data.");
        }
    };

    return {
        getPremiumPricing,
        addPremiumPricing,
        updatePremiumPricing,
        deletePremiumPricing,
    };
};
